import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import {
  type FirstSponMessage,
  isFirstSponMessage,
  isRecommendMessage,
  type RecommendMessage,
} from '@module/types/centrifuge/public-message/etcMessageTypes';
import {
  type FanInMessage,
  isFanInMessage,
  isKingFanInMessage,
  type KingFanInMessage,
} from '@module/types/centrifuge/public-message/inMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class RecommendHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<RecommendMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isRecommendMessage(payload);
  }

  handle(payload: RecommendMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.triggers?.castSettingRecommendEffect?.();
  }
}

export class KingFanInHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<KingFanInMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isKingFanInMessage(payload);
  }

  handle(payload: KingFanInMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.triggers?.playCastSettingKingFanInAudio?.();
  }
}

export class FanInHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<FanInMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isFanInMessage(payload);
  }

  handle(payload: FanInMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.triggers?.playCastSettingFanInAudio?.();
  }
}

export class FirstSponHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<FirstSponMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isFirstSponMessage(payload);
  }

  handle(payload: FirstSponMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.triggers?.firstSpon?.(payload);
  }
}
